import { Toolbar } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useInsightEnvironment } from 'shared/hooks';
import { I2PEnvironment } from 'shared/types';

const determineHeaderColor = (environment: I2PEnvironment) =>
  environment === 'dev' ? 'common.black' : environment === 'sandbox' ? 'secondary.main' : undefined;

export function ColoredToolbar({ children }: PropsWithChildren<{}>) {
  const environment = useInsightEnvironment();
  return (
    <Toolbar
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        backgroundColor: determineHeaderColor(environment),
      }}
    >
      {children}
    </Toolbar>
  );
}
